/**
 * 获取创作详情
 * @param {string} oid - 创意作品的 oid
 * @returns {Promise<any|null>} 成功且状态为200时返回res.body，否则返回null
 */
export async function fetchCreationDetail (oid) {
    try {
        const response = await fetch('https://community-web.ccw.site/creation/detail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ oid })
        });

        const res = await response.json();

        if (res && res.status === 200) {
            return res.body;
        } else {
            return null;
        }
    } catch (error) {
        console.error('获取创作详情失败:', error);
        return null;
    }
}

/**
 * 获取创作的发布版本列表
 * @param {string} creationOid - 创意作品的 oid
 * @param {number} page - 页码（从1开始）
 * @param {boolean} withProfiling - 是否包含分析数据
 * @returns {Promise<any|null>} 成功且状态为200时返回res.body.data，否则返回null
 */
export async function fetchCreationReleases (creationOid, page, withProfiling) {
    try {
        const response = await fetch(`https://community-web.ccw.site/creation_release/page?page=${page}&perPage=20&sortField=submittedAt&sortType=DESC`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                creationOid: creationOid,
                page: page,
                perPage: 20,
                sortField: 'submittedAt',
                sortType: 'DESC',
                withProfiling: withProfiling
            })
        });

        const res = await response.json();

        if (res && res.status === 200 && res.body) {
            return res.body.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('获取创作发布版本列表失败:', error);
        return null;
    }
}

/**
 * POST请求获取用户详情
 * @returns {Promise<any|null>} 成功且状态为200时返回res.body，否则返回null
 */
export async function postMemberDetail (token) {
    try {
        const response = await fetch('https://community-web.ccw.site/study-community/member/detail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                token
            },
            body: JSON.stringify({})
        });

        const res = await response.json();

        if (res && res.status === 200) {
            return res.body;
        } else {
            return null;
        }
    } catch (error) {
        console.error('获取用户详情失败:', error);
        return null;
    }
}

/**
 * GET请求验证会话
 * @param {string} token - 入参token
 * @returns {Promise<any|null>} 成功且状态为200时返回res.body，否则返回null
 */
export async function getTouchSession (token) {
    try {
        const response = await fetch(`https://sso.ccw.site/internal/auth/touch-session?token=${encodeURIComponent(token)}`, {
            method: 'GET'
        });

        const res = await response.json();

        if (res && res.status === 200) {
            return res.body;
        } else {
            return null;
        }
    } catch (error) {
        console.error('验证会话失败:', error);
        return null;
    }
}

/**
 * POST请求通过密码登录
 * @param {string} loginKey - 登录账号
 * @param {string} clientCode - 客户端编码
 * @param {string} password - 密码
 * @param {any} extra - 额外参数（会被JSON.stringify处理）
 * @returns {Promise<any|null>} 成功且状态为200时返回res.body，否则返回null
 */
export async function postLoginByPassword (loginKey, clientCode, password, extra) {
    try {
        const response = await fetch('https://sso.ccw.site/web/auth/login-by-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                loginKey: loginKey,
                clientCode: clientCode,
                password: password,
                extra: JSON.stringify(extra)
            })
        });

        const res = await response.json();

        if (res && res.status === 200) {
            return res.body;
        } else {
            return null;
        }
    } catch (error) {
        console.error('密码登录请求失败:', error);
        return null;
    }
}